import React from "react";

// Realistic Agni Shiksha TEST INTERFACE mockup — pure CSS, no images.
export function TestInterfaceMockup({ className = "" }) {
  const palette = [
    "answered", "answered", "review", "answered", "notanswered",
    "answered", "ansreview", "answered", "answered", "notvisited",
    "answered", "notanswered", "answered", "review", "notvisited",
    "notvisited", "notvisited", "notvisited", "notvisited", "notvisited",
  ];
  const colors = {
    answered: "#22C55E", notanswered: "#EF4444", review: "#8B5CF6", ansreview: "#A855F7", notvisited: "#1f2a3a",
  };
  return (
    <div className={`panel p-3 sm:p-4 shadow-2xl ${className}`}>
      {/* window chrome */}
      <div className="flex items-center gap-1.5 px-1 pb-3">
        <span className="w-2.5 h-2.5 rounded-full bg-[#ff5f57]" /><span className="w-2.5 h-2.5 rounded-full bg-[#febc2e]" /><span className="w-2.5 h-2.5 rounded-full bg-[#28c840]" />
        <span className="ml-2 text-[11px] text-content-muted font-mono truncate">agnishiksha.in · SSC CGL — Full Mock 01</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-3">
        {/* Question card */}
        <div className="rounded-xl bg-ink border border-line p-4">
          <div className="flex items-center justify-between mb-3">
            <span className="text-[11px] text-content-secondary">Question 14 · <span className="text-content">Quant</span></span>
            <span className="font-mono text-xs px-2 py-1 rounded-md bg-ember/10 text-ember">28:14</span>
          </div>
          <p className="text-[13px] leading-relaxed mb-4 text-content">A train 240 m long crosses a pole in 12 seconds. What is its speed?</p>
          <div className="space-y-2">
            {["72 km/h", "60 km/h", "54 km/h", "45 km/h"].map((o, i) => (
              <div key={i} className={`text-[12px] px-3 py-2 rounded-lg border flex items-center gap-2.5 ${i === 0 ? "border-ember/70 bg-ember/10" : "border-line"}`}>
                <span className={`w-4 h-4 rounded-full border flex items-center justify-center text-[9px] font-mono ${i === 0 ? "border-ember bg-ember text-ink" : "border-content-muted text-content-muted"}`}>{"ABCD"[i]}</span>
                <span className={i === 0 ? "text-content" : "text-content-secondary"}>{o}</span>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-between mt-4">
            <span className="text-[11px] text-content-muted">Marks +2 · −0.5</span>
            <span className="text-[11px] font-semibold px-3 py-1.5 rounded-lg btn-ember">Save & Next</span>
          </div>
        </div>
        {/* Palette */}
        <div className="rounded-xl bg-ink border border-line p-3 sm:w-[132px]">
          <div className="text-[10px] text-content-muted mb-2 uppercase tracking-wide">Palette</div>
          <div className="grid grid-cols-5 gap-1.5">
            {palette.map((s, i) => (
              <span key={i} className="aspect-square rounded-md text-[8px] font-mono flex items-center justify-center text-white/90" style={{ background: colors[s] }}>{i + 1}</span>
            ))}
          </div>
          <div className="mt-3 space-y-1">
            <div className="flex justify-between text-[9px]"><span className="text-content-muted">Answered</span><span className="text-status-answered">11</span></div>
            <div className="flex justify-between text-[9px]"><span className="text-content-muted">Review</span><span className="text-status-review">2</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Result / performance analytics mockup
export function AnalyticsMockup({ className = "" }) {
  const subjects = [
    { s: "Reasoning", v: 88 }, { s: "Quant", v: 72 }, { s: "English", v: 64 }, { s: "GK", v: 51 },
  ];
  const score = 82;
  const R = 34, C = 2 * Math.PI * R;
  return (
    <div className={`panel p-4 sm:p-5 shadow-2xl ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[11px] text-content-muted uppercase tracking-wide">Result</div>
          <div className="font-heading font-semibold text-sm">Performance Analysis</div>
        </div>
        <span className="chip !py-1 !text-[10px]">All India Rank #142</span>
      </div>
      <div className="grid grid-cols-[auto_1fr] gap-5 items-center mb-5">
        <div className="relative w-[92px] h-[92px]">
          <svg viewBox="0 0 80 80" className="w-full h-full -rotate-90">
            <circle cx="40" cy="40" r={R} fill="none" stroke="#1f2a3a" strokeWidth="7" />
            <circle cx="40" cy="40" r={R} fill="none" stroke="#F97316" strokeWidth="7" strokeLinecap="round" strokeDasharray={C} strokeDashoffset={C * (1 - score / 100)} />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="font-heading font-bold text-xl">{score}%</span>
            <span className="text-[9px] text-content-muted">score</span>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {[["Accuracy", "86%"], ["Attempted", "94/100"], ["Time/Q", "34s"]].map(([k, v]) => (
            <div key={k} className="rounded-lg bg-ink border border-line px-2.5 py-2">
              <div className="font-heading font-semibold text-sm">{v}</div>
              <div className="text-[10px] text-content-muted">{k}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="space-y-2.5">
        <div className="text-[11px] text-content-muted uppercase tracking-wide mb-1">Subject accuracy</div>
        {subjects.map((x) => (
          <div key={x.s}>
            <div className="flex justify-between text-[11px] mb-1"><span className="text-content-secondary">{x.s}</span><span className="font-mono text-content-secondary">{x.v}%</span></div>
            <div className="h-1.5 rounded-full bg-ink overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${x.v}%`, background: x.v >= 65 ? "#22C55E" : "#F97316" }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
